// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3wamX","buttons":"PendingPaymentAlert_buttons__pH1O0"};